import "./App.css";
import { Routes, Route } from "react-router-dom";
import Home from './pages/home/Home.js';
import Registro from "./pages/registro/registro";
import Bienvenido from "./pages/Bienvenido/Bienvenido";
import IngresoDNI from "./pages/ingresoDNI/ingresoDni";
import Resultado from "./pages/Resultado/Resultado";
import Excel from "./pages/excel/excel";
import Home2 from "./pages2/home/Home";
import Registro2 from "./pages2/registro/registro";
import IngresoDNI2 from "./pages2/ingresoDNI/ingresoDni";
import Bienvenido2 from "./pages2/Bienvenido/Bienvenido";
import Resultado2 from "./pages2/Resultado/Resultado";

// import TerminosYcondiciones from "./components/terminosYcondiciones/terminosYcondiciones";


function App() {
  return (
      <Routes>
         {/* <Route path="/prueba" element={<Home />} />  
         <Route path="/Registro" element={<Registro />} /> 
         <Route path="/Bienvenido" element={<Bienvenido />} /> 
         <Route path="/IngresoDNI" element={<IngresoDNI />} />  
         <Route path="/Resultado" element={<Resultado />} /> 
         <Route path="/Excel" element={<Excel />} />  
         {/* <Route path="/tyc" element={<TerminosYcondiciones />} />  */}
         <Route path="/" element={<Home2 />} /> 
         <Route path="/Registro" element={<Registro2 />} /> 
         <Route path="/IngresoDNI" element={<IngresoDNI2 />} />   
         <Route path="/Bienvenido" element={<Bienvenido2 />} />   
         <Route path="/Resultado" element={<Resultado2 />} /> 
         <Route path="/Excel" element={<Excel />} />  
      </Routes>   
  );
}

export default App;
